export default __webpack_public_path__ + "static/media/4.cf65bdeb.png";